<template>
    <modal root-id="register-plan-modal" root-classes="modal show" modal-width="modal-2xl" :ignore-escape="true">
        <template #modal-container>
            <h3 class="md:text-3xl text-2xl text-center mt-4">Elige un plan</h3>
            <p class="text-gray-500 text-center mt-2">
                Para continuar con tu registro en Círculo Plus elige uno de nuestros planes y disfruta de promociones
                exclusivas.
            </p>
            <plans
                rootClasses="grid sm:grid-cols-2 grid-cols-1 sm:gap-2 gap-7 sm:mt-6 mt-4"
                loopClasses="sm:col-span-1"
                section="register-modal"
                @bubbleUpPlanSelected="planWasSelectedListener"
            ></plans>
            <div class="relative flex items-start justify-center md:mt-5 mt-4">
                <a
                    href="#"
                    class="flex items-center text-sm text-blue-500 hover:text-blue-700 duration-300 ease-in-out"
                >
                    Ya tengo un código
                    <svg
                        class="w-5 ml-1"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                        />
                    </svg>
                </a>
            </div>
            <p class="text-sm mt-4">
                Durante tu periodo de prueba podrás usar todos los <strong>beneficios</strong> que
                <strong class="text-red-500">Círculo Plus</strong> tiene para ti, como descuentos exclusivos en tiendas
                <strong class="text-red-500">Sanborns</strong> y <strong class="text-red-500">Sears</strong>,
                promociones con aliados comerciales en todo México, entradas para el cine y otros eventos gratis.
            </p>
        </template>
    </modal>
</template>

<script>
import Modal from './Modal';
import Plans from './Plans';

export default {
    components: {
        Modal,
        Plans,
    },

    methods: {
        planWasSelectedListener(plan) {
            this.$emit('bubbleUpSelectedPlan', plan);
        },
    },
};
</script>
